import React, {useEffect, useState} from "react";
import { useLocation } from 'react-router-dom';
import './About.css';
import Footer from "./Footer";

const About = () => {
  const location = useLocation();

  const [showScroll, setShowScroll] = useState(false);

  // Show button when scroll position is > 200px
  const checkScrollPosition = () => {
    if (window.scrollY > 200) {
      setShowScroll(true);  // Show the button
    } else {
      setShowScroll(false); // Hide the button
    }
  };

  // Scroll to top function
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace('#', '');
      const section = document.getElementById(id);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  }, [location]);
  return (
    <div>
      <section id="genesis">
      <h1 style={{ textAlign: 'center', fontSize:'1.5rem'}}>Genesis of TISSAA</h1>
      
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        The Tata Institute of Social Sciences Alums Association (TISSAA) was established to strengthen the bonds among TISS Alums and foster lifelong connections. The journey began in 2007 when TISS, along with the students' union, organized the first national Alums meet, which brought over 1,000 Alums together. This event sparked a demand for a formal Alums association. In 2012, during TISS's Platinum Jubilee, a more serious effort was made by senior Alums, with support from the institute's leadership, to establish a sustainable platform for Alums engagement. This led to the creation and registration of TISSAA in 2012-13.
      </p>
      <p style={{ marginLeft: '20px' , marginBottom:'30px',textAlign: 'justify', marginRight: "20px"}}>
        TISSAA is a vibrant, diverse community of Alums from across TISS campuses, encompassing professionals, scholars, researchers, entrepreneurs, and change-makers. The association serves as a bridge between TISS and its Alums, fostering connections, supporting professional growth, and promoting community engagement. Through collaborative initiatives and a shared commitment to academic excellence, knowledge exchange, and upskilling, TISSAA creates opportunities for Alums to contribute to meaningful projects and celebrate each other's achievements. The association is dedicated to nurturing an inclusive environment where members can thrive, exchange ideas, and continue making a positive impact.
      </p>
      </section>
      <button
            className="scroll-to-top"
            onClick={scrollToTop}
          >
            ↑ Top
          </button>

      {/* Section for Message */}
      <section id="message">
      <h1 style={{ textAlign: 'center' , fontSize:'1.5rem'}}>Message from TISSAA</h1>
      <p style={{ marginLeft: '20px',textAlign: 'justify', marginRight: "20px" }}>
        Dear Alums, <br />
        Warm greetings!
      </p>
      <p style={{ marginLeft: '20px',textAlign: 'justify', marginRight: "20px" }}>
        It is our pleasure to welcome you to the Tata Institute of Social Sciences Alums Association (TISSAA). Our mission is to support and connect our Alums, creating a lasting impact for both you and the Institute.
        As life progresses, with professional and family commitments, it’s easy to lose touch with classmates, batchmates, and faculty. TISSAA aims to bridge that gap by offering various programs and activities to help you reconnect with your peers and mentors. Whether through national and regional Alums meets, on-campus events, job posting services, or social media platforms, we are here to help you stay connected and thrive.
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        TISSAA’s global Alums network is vast, and we encourage you to stay engaged, explore the opportunities available, and take full advantage of our resources. Your success is at the heart of our mission, and we are committed to supporting you in your professional journey.
      </p>
      <p style={{ marginLeft: '20px',textAlign: 'justify', marginRight: "20px" }}>
        We also invite you to consider ways you can give back to the Institute, whether through career guidance, academic mentoring, volunteering, or simply participating in our events. Your involvement, no matter how big or small, makes a significant difference, and the rewards of giving back are immeasurable.
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        Thank you for visiting us today! We encourage you to explore all the ways you can connect, grow, and contribute to making TISSAA stronger. We’re always here to assist with any questions you may have.
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        Warm regards, <br />
        TISSAA Team
      </p>
      </section>

      {/* Section for Purpose */}
      <section id="purpose">
      <h1 style={{ textAlign: 'center' , fontSize:'1.5rem'}}>Purpose of TISSAA</h1>
      <p style={{ marginLeft: '20px',textAlign: 'justify', marginRight: "20px" }}>
        At TISSAA, our purpose is to connect, empower, and inspire our Alums while making a positive and lasting impact on society. Our mission is driven by four key pillars that shape our vision:
      </p>
      <p style={{ marginLeft: '20px',textAlign: 'justify', marginRight: "20px" }}>
        <strong>• Lifelong Connections:</strong> We strive to build enduring relationships among Alums, providing platforms for engagement through regional and national events, online networks, and professional collaborations. Our goal is to create meaningful connections that support both personal and professional growth.
      </p>
      <p style={{ marginLeft: '20px',textAlign: 'justify', marginRight: "20px" }}>
        <strong>• Empowerment and Growth:</strong> We are committed to empowering Alums by offering resources for professional development, including workshops, mentorship programs, and career advancement tools. Our aim is to help Alums reach their potential and contribute meaningfully to their respective fields.
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        <strong>• Social Impact and Advocacy:</strong> Leveraging the collective strength of our Alums, we drive social change through initiatives focused on societal challenges, justice, and sustainability. We advocate for equity and aim to use the diverse expertise within our network to create a positive impact on communities.
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px", marginBottom:'40px'}}>
        <strong>• Meaningful Engagement:</strong> We foster purposeful engagement by supporting Alums-led initiatives and facilitating collaboration within our network. Our aim is to drive both social and professional advancement through innovation, creating lasting contributions to society and the Alums community.
      </p>
      </section>

      {/* Section for Objectives */}
      <section id="objectives">
      <h1 style={{ textAlign: 'center' , fontSize:'1.5rem'}}>Objectives of TISSAA</h1>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        The objectives for which TISSAA has been established are as follows:
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        <strong>•</strong> To promote and foster mutually beneficial interactions between Alums worldwide, Tata Institute of Social Sciences, current students, and among Alums themselves.
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        <strong>•</strong> To encourage and facilitate the Institute's educational, research, field action projects, enterprises, and other activities, along with supporting Alums initiatives.
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        <strong>•</strong> To develop programs of interest to Alums that promote personal and professional growth.
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        <strong>•</strong> To inspire Alums to actively support the progress of the Institute, contributing to the enhancement of its social impact.
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        <strong>•</strong> To assist students and Alums in their growth by offering scholarships, awards, and mentorship in academic and extracurricular pursuits such as research and fieldwork.
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>
        <strong>•</strong> To accept and manage bequests, gifts, donations, loans, or subscriptions to create and maintain a fund for the association's objectives.
      </p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px", marginBottom:'40px'}}>
        <strong>•</strong> To undertake any lawful activities that further the attainment of these objectives and serve the interests of both the Institute and its Alums.
      </p>
      </section>

      {/* Section for Trustees */}
      <section id="trustees">
      <h1 style={{ textAlign: 'center' , fontSize:'1.5rem'}}>Trustees</h1>
      <p style={{ marginLeft: '20px',textAlign: 'justify', marginRight: "20px" }}>➥ Dr. Sanjaya Pradhan (MSW, 2007) (Ph.D, 2018)</p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>➥ Dr. Vrindra Khattar (MSW, 1999)</p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>➥ Dr. Swapan Garain (MSW, 1983)</p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>➥ Mr. Satya Naidu (MSW, 2010)</p>
      <p style={{ marginLeft: '20px',textAlign: 'justify', marginRight: "20px" }}>➥ Dr. Marrianpan (Ph.D, 2010)</p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>➥ Mrs. Himani Rawat (MSW, 2007)</p>
      <p style={{ marginLeft: '20px' ,textAlign: 'justify', marginRight: "20px"}}>➥ Dr. Nitin Kamble (MSW, 2007)</p>
      </section>

      {/* Section for Managing Committee Members */}
      <section id="managingCommitteeMembers">
      <h1 style={{ textAlign: 'center', fontSize:'1.5rem'}}>Managing Committee Members</h1>
      <p style={{ marginLeft: '20px' }}><strong>Managing Committee (2022-2025)</strong></p>
      <p style={{ marginLeft: '20px' }}>➤ Mrs. Nandini Janardhanan, President (MSW, 1995)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mr. Stalin Nayak, Secretary General (MSW, 2014)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mrs. Paulomi Chakraborty (MSW, 2016)</p>
      <p style={{ marginLeft: '20px' }}>➤ Dr. Raju S M G (MHA, 2010)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mr. Anand Jagtap, Co-opted Member (MSW)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mr. Vikramjeet Singh, Co-opted Member (MSW, 2007)</p>
      <p style={{ marginLeft: '20px' }}>➤ Dr. Amitabh Mehrothra (1985-87)  </p><br></br>

      <p style={{ marginLeft: '20px' }}><strong>Managing Committee (2017-2022)  </strong></p>
      <p style={{ marginLeft: '20px' }}>➤ Mr. Pravin Shashtri</p>
      <p style={{ marginLeft: '20px' }}>➤ Dr. Nitin Kamble, MSW - 2007</p><br></br>

      <p style={{ marginLeft: '20px' }}><strong>Managing Committee (2014-2017)</strong></p>
      <p style={{ marginLeft: '20px' }}>➤ Mr. Arun Kaimal, President (PMIR/HRM 2007)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mr. Sobins Kuriakose, Vice President (2007)</p>
      <p style={{ marginLeft: '20px' }}>➤ Dr. Swapan G, Secretary General (1983)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mr. Satya Naidu, Treasurer (2010)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mr.Jaffar Latief (2014)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mr.Pravin Shastri (1972)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mr.Satish Kalra (1974)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mr.Amalendu Pal (1982)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mr.Sunil Dalvi (1994)</p>
      <p style={{ marginLeft: '20px' }}>➤ Mrs.Shakti Bhise, Co-opted Member (2007)</p>
      <p style={{ marginLeft: '20px' }}>➤ Dr. Nitin Kamble, Co-opted Member (MSW, 2007)</p>
      </section>
      <Footer/>
        
    </div>
  );
};

export default About;







// import React from "react";
// import Genesis from './About/Genesis';
// import Message from './About/Message';
// import Purpose from './About/Purpose';
// import Trustees from './About/Trustees';
// import Objectives from './About/Objectives';
// import ManagingCommitteeMembers from './About/ManagingCommitteeMembers';

// const About = () => {
//   return (
//     <div>

//       {/* Section for Genesis */}
//       <div id="genesis">
//         <Genesis />
//       </div>

//       {/* Section for Message */}
//       <div id="message">
       
//         <Message />
//       </div>

//       {/* Section for Purpose */}
//       <div id="purpose">
        
//         <Purpose />
//       </div>

//       {/* Section for Objectives */}
//       <div id="objectives">
       
//         <Objectives />
//       </div>

//       {/* Section for Trustees */}
//       <div id="trustees">
        
//         <Trustees />
//       </div>

//       {/* Section for Managing Committee Members */}
//       <div id="managingCommitteeMembers">
//         <ManagingCommitteeMembers />
//       </div>
//     </div>
//   );
// };

// export default About;
